// extracted by mini-css-extract-plugin
export default {"skip-link":"skip-link--8GyIz","skipLink":"skip-link--8GyIz","skip-link__skip-nav":"skip-link__skip-nav---20BL","skipLinkSkipNav":"skip-link__skip-nav---20BL"};